export default defineNuxtPlugin(() => {
  const { initConsent } = useCookieConsent()
  initConsent()
})